import { render, staticRenderFns } from "./datapage.vue?vue&type=template&id=32dce32d"
import script from "./datapage.vue?vue&type=script&lang=js"
export * from "./datapage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports